import React, { Component } from 'react';
import numeral from 'numeral';
import CategoryCard from '../CategoryCard/CategoryCard';

import '../AttackCategories/AttackCategories.scss';
import settingsIconPath from '../../../public/img/settings.png';
import unsecuredShieldIconPath from '../../../public/img/unsecured-shield.png';

class AttackCategories extends Component {
  getAllTimeCount(cat, monthly, allTimeCatCount) {
    let count = 0;
    monthly.forEach((mth) => {
      if (mth[cat] > 0) {
        count += mth[cat];
      }
    });
    return Math.max(count, allTimeCatCount);
  }

  monthlyAvg(monthly, cat) {
    let numMonths = 0;
    let count = 0;
    monthly.forEach((mth) => {
      if (mth[cat] > 0) {
        count += mth[cat];
        numMonths += 1;
      }
    });
    if (numMonths === 0) return 0;
    return this.formatNum(count / numMonths);
  }

  formatNum(n) {
    return numeral(n).format('0,0');
  }

  catPercentage(catTotal, catCount) {
    return numeral(catCount / catTotal).format('0.0%');
  }

  render() {
    const allTime = this.props.bundleSummary.attack_cat_all_time;
    const monthly = this.props.bundleSummary.attack_cat_monthly;

    if (!allTime || !monthly) {
      return null;
    }

    const allTimeCorrected = {};
    let catTotal = 0;
    for (const k in allTime) {
      if (!allTime.hasOwnProperty(k)) continue;
      const curCount = this.getAllTimeCount(k, monthly, allTime[k]);
      allTimeCorrected[k] = curCount;
      catTotal += curCount;
    }

    return (
      <div className="categories-container md-grid mobile-fix misconfig-container">
        <h2 className="whos-spying">
          Potential downtime due to misconfiguration
        </h2>
        <CategoryCard
          id="misconfig"
          title="App Misconfiguration"
          titleAvatar={settingsIconPath}
          numTotalIncidents={this.formatNum(allTimeCorrected.misconfiguration)}
          numMonthlyAvg={this.monthlyAvg(monthly, 'misconfiguration')}
          percentage={this.catPercentage(
            catTotal,
            allTimeCorrected.misconfiguration,
          )}
          prose="due to app problems that cause users to be unable to establish secure connections to your servers"
          dataLeakedA="All private communications"
          iconA={unsecuredShieldIconPath}
          complianceA="SOC 2"
          whyText="Various forms of misconfigurations on the client or server can cause SSL certificate validation errors to occur. If these occurrences are high, it is usually due to server misconfigurations that you should and can easily fix."
          riskText="SSL misconfigurations are more common than you might think, and leave a gaping hole for snooping attackers to exploit."
          riskScoreMalice={1.0}
          riskScoreExposure={10.0}
          riskScoreBreach={9.0}
        />
      </div>
    );
  }
}

export default AttackCategories;



// WEBPACK FOOTER //
// ./src/components/MisconfigCategories/MisconfigCategories.jsx